import React from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { useSelector, useDispatch, connect } from 'react-redux'
import { OnProceedWithEstimate } from '../../actions/proceedEstimateActions'
import { useHistory } from 'react-router-dom'
import { fireInteractionCustomEvent } from '../../helpers'
import { PrimaryButton } from '@mmsg/louie'

const ProceedWithEstimateButton = (props) => {
  const dispatch = useDispatch()
  const history = useHistory()
  let isProceedEstimateAccepted = useSelector(
    (state) => state.opportunity && state.opportunity.hasIndicativeProposal
  )
  let isSubmissionInProgress = useSelector(
    (state) => state.proceedEstimate && state.proceedEstimate.isSubmitting
  )
  return (
    <>
      {isProceedEstimateAccepted && (
        <>
          <PrimaryButton
            variant={props.variant}
            size={props.size}
            className="d-block mx-auto mt-3 mb-24 readonly"
            extendInMob
            id={props.id}
          >
            {props.launchText}
          </PrimaryButton>
        </>
      )}
      {!isProceedEstimateAccepted && (
        <>
          {isSubmissionInProgress ? (
            <PrimaryButton
              variant={props.variant}
              size={props.size}
              className={props.className}
              extendInMob
              id={props.id}
            >
              <>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="mb-1"
                  id="submittingspinner"
                />
                Submitting...
              </>
            </PrimaryButton>
          ) : (
            <PrimaryButton
              variant={props.variant}
              size={props.size}
              className={props.className}
              extendInMob
              id={props.id}
              onClick={() => {
                dispatch(
                  OnProceedWithEstimate(
                    props.opportunityId,
                    props.estimateId,
                    history
                  )
                )
                fireInteractionCustomEvent({
                  detail: {
                    eventType: 'custom link click',
                    data: {
                      category: 'button',
                      section: 'mylease',
                      text: 'proceed estimate',
                      label: 'proceed estimate',
                    },
                  },
                })
              }}
            >
              {props.launchText}
            </PrimaryButton>
          )}
        </>
      )}
    </>
  )
}

function mapStateToProps(state) {
  return {
    proceedEstimate: state.proceedEstimate,
  }
}

export default connect(mapStateToProps)(ProceedWithEstimateButton)
